import { memo } from 'react';
import { makeClassName, pluralize } from '@siteless/util';
import avatars from '../config/avatars';
import useCopy from '../util/useCopy';
import { PopWrapper } from './PopWrapper';
import LetterboxdIcon from './LetterboxdIcon';
import CrownIcon from './CrownIcon';
import { oscarDatabase } from '../config/constants';

let CATEGORY_COUNT = Object.keys(oscarDatabase.nomineeCategories).length;

type UserItem = {
  key: string;
  ArtworkComponent: (typeof avatars)[keyof typeof avatars]['ArtworkComponent'];
  handle?: string;
  avatarBackgroundHex?: string | null;
  letterboxdId?: string | null;
};

export let MobileBallotItem = memo(({
  item,
  itemIndex,
  points,
  useStrictScore,
  isCurrentUser,
  isOwner,
  onSelectBallot,
}: {
  item: UserItem;
  itemIndex: number;
  points?: number;
  useStrictScore?: boolean;
  isCurrentUser: boolean;
  isOwner?: boolean;
  onSelectBallot?: (ballotKey: string) => void;
}) => {
  let copy = useCopy();

  return (
    <div
      className={makeClassName(
        'relative z-10 mx-auto flex w-40 flex-col items-center',
        itemIndex % 2 ? '-right-12' : '-left-12',
        isCurrentUser && '--current-user',
      )}
      onClick={() => onSelectBallot?.(item.key)}
    >
      <div>
        <PopWrapper>
          <item.ArtworkComponent
            className="h-24 w-24 shadow-md"
            backgroundColor={item.avatarBackgroundHex || undefined}
          />
        </PopWrapper>
      </div>
      <div className="__handle mt-2 max-w-[208px] truncate px-2 text-center">
        {item.handle}
        {isOwner && (
          <CrownIcon className="ml-1 inline-block h-4 w-4 text-purple-400" />
        )}
        {item.letterboxdId && (
          <LetterboxdIcon className="ml-1 inline-block h-4 w-4 text-purple-400" />
        )}
      </div>
      <div className="px-2 text-center text-purple-300">
        {typeof points === 'number'
          ? useStrictScore
            ? `${points} / ${CATEGORY_COUNT}`
            : pluralize({
                count: points,
                singular: copy.point,
              })
          : null}
      </div>
    </div>
  );
});
